import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'age'
})
export class ToAgePipe implements PipeTransform {

    transform(value: any): string {
        if (value && value.indexOf('-') > 1) {
            const today = moment();
            const birthdate = moment(value);
            const years = today.diff(birthdate, 'years');
            const months = today.subtract(years, 'years').diff(birthdate, 'months');
            let html: string = years + ' ans ';

            if (months > 0) {
                html += months + ' mois';
            }

            return html;
        } else {
            return '-';
        }
    }

}



// WEBPACK FOOTER //
// ./src/shared/pipes/toAge.pipe.ts